import axios from 'axios';
import env from '../config';
import UserService from './UserService';

const defaultInstance = axios.create({
  baseURL: `${env.api.url}${env.api.basePath || ''}`,
  responseType: 'json',
});

const injectToken = (config) => {
  const cb = () => {
    const token = UserService.getToken();
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = token ? `bearer ${token}` : '';

    return Promise.resolve(config);
  };
  return UserService.updateToken(cb);
};

defaultInstance.interceptors.request.use(injectToken);

export default {
  defaultInstance,
};
